{
  "labels": {
    "skeniraj": "Scan the code below with your authenticator:",
    "vnesiKodo": "Enter the code generated in the authenticator",
    "prepisi": "Copy the code into the authenticator:",
    "kodaNiVidna": "If you don't see the code, click here to display it",
    "skrij": "Hide code",
    "nastavljeno": "2FA is already set up for this account",
    "niNastavljeno": "2FA is not yet set up for this account",
    "buttons": {
      "odpri": "Enable / Disable 2FA",
      "vklopi": "Enable two-factor authentication",
      "izklopi": "Disable two-factor authentication",
      "ponastavi": "Reset authenticator",
      "generiranje": "Activation in progress",
      "deaktivacija": "Deactivation in progress",
      "ponastavljanje": "Resetting in progress",
      "potrdiKodo": "Confirm code"
    }
  },
  "obvestila": {
    "napakaBranja": "Error reading data.",
    "napakaInputa": "Code field cannot be empty!",
    "vprasanjeIzklopa": "Are you sure you want to disable 2FA?",
    "izklopUspesen": "2FA successfully disabled.",
    "vklopUspesen": "2FA successfully enabled.",
    "niUjemanja": "Entered code does not match. Please check the code and try again!"
  }
}